// extracted by mini-css-extract-plugin
export default {"wrapper":"Program_wrapper__Woofx","mobileCoverVisible":"Program_mobileCoverVisible__4az3j","fixedWidth":"Program_fixedWidth__vDJ8X"};